import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import store from './store'
import router from './router'
import VXETable from 'vxe-table'
import { copy } from './utils/'
import { hasPermission, PERMISSIONS } from './utils/permission'
import permissionDirective from './directives/permission'
import 'vxe-table/lib/style.css'

import 'ant-design-vue/dist/antd.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueDraggableResizable from 'vue-draggable-resizable'
import { Sortable } from 'sortablejs'
import '@/styles/index.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)

import './permission'
import urlFilter from './utils/url-filter'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VXETable)

// 按钮级权限：注册 v-permission 指令与全局校验方法（详见 src/utils/permission.js）
// PERMISSIONS 需挂载到实例原型，模板中的 v-permission="PERMISSIONS.XXX" 才能正确解析
Vue.directive('permission', permissionDirective)
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.PERMISSIONS = PERMISSIONS

Vue.mixin({
  created() {
    this.URL_FILTER = urlFilter
    this.ATableComponents = {
      header: {
        cell: (h, props, children) => {
          const { key, ...restProps } = props
          const col = this.columns.find(colItem => {
            const k = colItem.dataIndex || colItem.key //列索引
            return k === key
          })

          if (!col || !col.width) {
            return h('th', { ...restProps }, [...children])
          }

          const dragProps = {
            key: col.dataIndex || col.key,
            class: 'table-draggable-handle',
            attrs: {
              w: 10,
              x: col.width,
              z: 1,
              axis: 'x',
              draggable: true,
              resizable: false
            },
            on: {
              dragging: x => {
                col.width = Math.max(x, 10) //留出空白
              }
            }
          }
          restProps.attrs.width = col.width
          const drag = h('vue-draggable-resizable', { ...dragProps })
          return h('th', { ...restProps, class: 'resize-table-th' }, [...children, drag])
        }
      }
    }
  }
})

// v-VXEtableDrag 实现vxe-table列拖拽
Vue.directive('VXEtableDrag', {
  bind: function (el, binding, vnode) {
    //拖拽时，生成dom
    var dragLoading = document.createElement('div')
    dragLoading.className = 'vxe-table--loading vxe-loading is--visible'
    dragLoading.style.display = 'none'
    dragLoading.innerHTML = `
      <div class="vxe-loading--spinner">
      
      </div>
    `
    el.querySelector('.vxe-table--body-wrapper').append(dragLoading)
    //获取路由参数以及组件顺序
    el.style.cursor = 'move'
    Sortable.create(el.querySelector('.vxe-header--row'), {
      draggable: 'th',
      handle: '.vxe-cell',
      animation: 500,
      direction: 'vertical',
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      forceFallback: true,

      onEnd: async e => {
        var oldCol = vnode.child.getColumns()
        var oldTarget = oldCol.splice(e.oldIndex, 1)
        oldCol.splice(e.newIndex, 0, oldTarget[0])

        vnode.child.refreshColumn()
        await vnode.child.loadColumn([])
        vnode.context.$nextTick(() => {
          vnode.child.loadColumn(oldCol)
          //保存排序信息
          var saveCol = []
          for (var i = 0; i < oldCol.length; i++) {
            saveCol.push({
              field: oldCol[i]['property'],
              fixed: oldCol[i]['fixed'] == 'right' ? true : false,
              fixedLeft: oldCol[i]['fixed'] == 'left' ? true : false,
              title: oldCol[i]['title'] || ''
            })
          }

          dragLoading.style.display = 'none'
        })
      }
    })
  }
})
Vue.prototype.$copy = copy

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
